import { historyService } from '../Services/serviceRegistration';
import { hashIt } from './utils';
import { Events } from './events';


export const goTo = (url: string, query?: string) => {
    Events.OnUrlStateChanged.invoke(url, query);
    historyService.push({ pathname: url, search: query, state: hashIt(url + query) });
};
